/**
 * Builds a URL query string from an object of parameters.
 * Filters out falsy values (null, undefined, empty strings) and properly encodes values.
 *
 * @param params - Object with key-value pairs for query parameters
 * @returns Query string (without the leading '?') or empty string if no valid params
 *
 * @example
 * buildQueryString({ userId: '123', page: 1, size: 10 })
 * // Returns: 'userId=123&page=1&size=10'
 *
 * @example
 * buildQueryString({ userId: '123', page: 0, empty: '' })
 * // Returns: 'userId=123&page=0' (empty string is filtered out)
 */
export const buildQueryString = (
  params: Record<string, string | number | boolean | null | undefined>
): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    // Skip null, undefined, and empty strings
    if (value !== null && value !== undefined && value !== "") {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
};
